import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
const promises = ['Vóór 22:00 besteld, morgen in huis', 'Gratis verzending vanaf € 50', 'Laagste prijsgarantie', '30 dagen bedenktijd'];
export function AnnouncementBar() {
  return <div className="bg-ink text-white" data-id="element-207" data-mp="1j3pjgcr4x24v">
      <div className="mx-auto flex h-9 max-w-7xl items-center justify-center gap-6 px-4 text-xs sm:px-6 md:justify-between lg:px-8" data-id="element-208" data-mp="1o1ziiyfzcmvr">
        <ul className="flex items-center gap-6" data-id="element-209" data-mp="rd1ltaoo6evy">
          {promises.map((p, i) => <li key={p} className={`items-center gap-1.5 whitespace-nowrap ${i === 0 ? 'flex' : i < 3 ? 'hidden md:flex' : 'hidden xl:flex'}`} data-id="element-210" data-mp="vcto55ngzosv" data-mpi={i}>
              <CheckIcon className="h-3.5 w-3.5 text-volt" strokeWidth={3} aria-hidden="true" data-id="element-211" data-mp="10erdmhmgrfu9" />
              {p}
            </li>)}
        </ul>
        <p className="hidden items-center gap-1.5 whitespace-nowrap text-white/80 lg:flex" data-id="element-212" data-mp="2bsmr7lxpzgjd">
          <span className="flex" aria-hidden="true" data-id="element-213" data-mp="2gq53nmay4dw4">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-volt text-volt" data-id="element-214" data-mp="10bnw5b16qkzw" />)}
          </span>
          <span data-id="element-215" data-mp="w9arkpy6ct4p">
            <span className="font-semibold text-white" data-id="element-216" data-mp="wavogm7yoo5q">4,8</span> · 6.200+ reviews
          </span>
        </p>
      </div>
    </div>;
}